module.exports = __webpack_public_path__ + "img/modelo-salgaderia.11a7abe9.png";